/// <reference path="../../../AppKitchen/typings/AppKitchen.UI.d.ts"/>
/// <reference path="../../typings/EEX.McEc.Api.d.ts"/>

module EEX.McEc.Data.Provider {

    export class CertificatesProvider extends AppKitchen.Data.Provider.ProviderBase {

        public load(): JQueryPromise<Domain.CertificateModel[]> {
            return this.do("Certificates");
        }
    }
}